module.exports = __webpack_public_path__ + "static/img/M_SLG.0dd81b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/M_SLG.jpg
// module id = 09Tg
// module chunks = 1